import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import { TDistributorSpecialPriceForm } from "../../../features/distributorSpecialPrices";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "../../../components/common/Inputs/CustomDatePicket";
import SelectFilter from "../../../components/common/Inputs/SelectFilter";
import { useProductsFilter } from "../../../features/products/hooks/useProducts";
import { useState } from "react";
import { useProduct } from "../../../features/products/hooks/useProduct";
import { useDebounce } from "../../../utils/useDebounce";

type DistributorSpecialPriceFormProps = {
  formik: FormikProps<TDistributorSpecialPriceForm>;
};

export const DistributorSpecialPriceForm = (
  props: DistributorSpecialPriceFormProps,
) => {
  const { formik } = props;
  const [productSearchTerm, setProductSearchTerm] = useState<string>("");
  // Debounce para búsqueda
  const debouncedSearchTerm = useDebounce(productSearchTerm, 500);

  // Fetch products for select filter
  const { data: products } = useProductsFilter({
    filter: { search: debouncedSearchTerm },
  });
  // Fetch selected product details
  const { data: productDetails } = useProduct({
    productId: formik.values.productId,
  });

  const handleProductChange = (value: string) => {
    formik.setFieldValue("productId", value);
  };

  const handleProductSearchChange = (value: string) => {
    setProductSearchTerm(value);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <SelectFilter
        label="Producto"
        data={products || []}
        dataKey={"_id"}
        dataLabel={"name"}
        selected={formik.values.productId || ""}
        selectedValue={productDetails}
        onSelect={handleProductChange}
        onSearchTermChange={handleProductSearchChange}
        error={
          formik.touched.productId &&
          formik.errors.productId &&
          Array.isArray(formik.errors.productId)
            ? formik.errors.productId.join(", ")
            : formik.errors.productId
        }
      />
      <CustomInput
        label="Precio"
        type="number"
        error={
          formik.touched.price &&
          formik.errors.price &&
          Array.isArray(formik.errors.price)
            ? formik.errors.price.join(", ")
            : formik.errors.price
        }
        {...formik.getFieldProps("price")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomDatePicker
        label="Fecha de inicio de vigencia"
        value={formik.values.effectiveFrom}
        handleChange={(date) => formik.setFieldValue("effectiveFrom", date)}
        error={
          formik.touched.effectiveFrom &&
          formik.errors.effectiveFrom &&
          typeof formik.errors.effectiveFrom === "string"
            ? formik.errors.effectiveFrom
            : undefined
        }
      />

      <CustomDatePicker
        label="Fecha de fin de vigencia"
        value={formik.values.effectiveTo}
        handleChange={(date) => formik.setFieldValue("effectiveTo", date)}
        error={
          formik.touched.effectiveTo &&
          formik.errors.effectiveTo &&
          typeof formik.errors.effectiveTo === "string"
            ? formik.errors.effectiveTo
            : undefined
        }
      />
    </div>
  );
};
